export default __webpack_public_path__ + "static/media/(34).cc042e62.JPG";